import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=0630e160&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=0630e160&prod&scoped=true&lang=css"
import style1 from "./Purchase.vue?vue&type=style&index=1&id=0630e160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630e160",
  null
  
)

export default component.exports